import React from 'react';
import { setLanguage } from '@eventbrite/i18n';
import { initializeRealUserMonitoring } from '@eventbrite/real-user-monitoring';

import Structure from './components/lean-eds/structure/Structure';
import appDirector from './managers/app-director';
import MapView from './views/map-view';

const { getView, getIsLoading } = appDirector;

const isProd = ({ env }) => {
    return env.ebDomain.indexOf('eventbrite') > -1;
};

const isQA = ({ env }) => {
    return env.ebDomain.indexOf('evbqa') > -1;
};

class App extends React.Component {
    constructor(props) {
        super(props);
        setLanguage(props.env.localeInfo.locale);
    }

    componentDidMount() {
        appDirector.on('change', this.onModelChange);

        if (isProd(this.props) || isQA(this.props)) {
            initializeRealUserMonitoring({
                sessionSampleRate: 14,
                version: this.props.app_version,
                service: this.props.app_name,
                env: isProd(this.props) ? 'prod' : 'evbqa',
            });
        }
    }

    componentWillUnmount() {
        appDirector.off('change', this.onModelChange);
    }

    onModelChange = () => {
        this.forceUpdate();
    };

    __handleAdditionalMenuTextItemSelect = () => undefined;

    render() {
        const viewData = getView();
        const isLoading = getIsLoading();
        const { params } = viewData;

        return (
            <div
                style={{
                    overflowY: 'hidden',
                    display: 'box',
                    boxFlex: 1,
                    height: '100vh',
                    width: '100%',
                }}
            >
                {isLoading ? (
                    <Structure
                        isLoading={true}
                        fullScreenMain={true}
                        navItems={[]}
                    >
                        <div />
                    </Structure>
                ) : (
                    <MapView viewParams={params} />
                )}
            </div>
        );
    }
}

export default App;
